module.exports = __webpack_public_path__ + "static/emma-bell-shuttleid-584d3074a186c785d5b0390c3dc712bb.jpg";